import { FC } from 'react';
import { Spinner } from 'react-bootstrap';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    mb?: string;
    mt?: string;
    white?: boolean;
    big?: boolean;
};

export const Loading: FC<propsType> = ({ big, mb, mt, white }) => {
    const isDarkMode = useGetIsDarkMode();

    return (
        <div className={`text-center ${white !== undefined ? white ? 'text-white' : '' : isDarkMode ? 'text-white' : ''}`}
            style={{
                marginBottom: mb,
                marginTop: mt
            }}
        >
            <Spinner animation={'grow'} role={'status'} /> &nbsp; &nbsp;
            <Spinner animation={'grow'} role={'status'} /> &nbsp; &nbsp;
            <Spinner animation={'grow'} role={'status'} /> &nbsp; &nbsp;
            <Spinner animation={'grow'} role={'status'} /> &nbsp; &nbsp;
            <Spinner animation={'grow'} role={'status'} />
            <div className={'animate__animated animate__pulse animate__infinite infinite animate__fast mt-3'}
                style={{ fontWeight: 'bolder', fontSize: big ? '1.3rem' : undefined }}
            >
                CARGANDO
            </div>
        </div>
    );
}
